import axios from 'axios';

export default {
  fetchCompany({
    commit,
  }, id) {
    return axios.get(`/company/show/${id}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'company',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  saveCompany(_, company) {
    return axios.post('/company', company);
  },
};
